import { Client, cacheExchange, fetchExchange } from 'urql';
import { accessToken } from './auth';
import { config } from './env';

// fetchOptions can't wait for a token refresh, so the refresh happens in a
// fetch wrapper instead.
const authFetch: typeof fetch = async (input, init) => {
  const token = await accessToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set('authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
};

export const createClient = () =>
  new Client({
    url: config.graphqlUrl,
    exchanges: [cacheExchange, fetchExchange],
    fetch: authFetch,
    // urql 5 sends queries as GET by default; arqam accepts only POST.
    preferGetMethod: false,
    requestPolicy: 'cache-and-network',
  });
